import { Expose, Type } from 'class-transformer';
import { DeliveryNoteVerifyStatus } from '../enums/delivery-note-verify-status.enum';
import { DNGateResult } from '../enums/dn-gate-result.enum';
import { User } from '@features/users/models/user';

export class DNGateOutcome {
  @Expose() result!: DNGateResult;
  @Expose() weight!: number;
  @Expose() contribution!: number;
}

export class DNVerifyGates {
  @Type(() => DNGateOutcome)
  @Expose() stamp!: DNGateOutcome;

  @Type(() => DNGateOutcome)
  @Expose() signature!: DNGateOutcome;

  @Type(() => DNGateOutcome)
  @Expose() dropOffDate!: DNGateOutcome;

  @Type(() => DNGateOutcome)
  @Expose() truckPlate!: DNGateOutcome;
}

export class DeliveryNoteVerificationDetails {
  @Expose() reason!: string;
  @Expose() status!: DeliveryNoteVerifyStatus;
  @Expose() confidenceScore?: number;

  @Type(() => DNVerifyGates)
  @Expose() gates?: DNVerifyGates;

  // Informational only - context for the reviewer, never part of the score.
  // Destination and driver are not gates, so this is the only place that data surfaces.
  @Expose() truckMatch!: boolean;
  @Expose() driverMatch!: boolean;
  @Expose() stampDetected!: boolean;
  @Expose() destinationMatch!: boolean;
  @Expose() signatureDetected!: boolean;

  // Legacy - superseded by `gates`, retained so pre-release rows still parse.
  // They can disagree with `status` (a DN can be Passed with gate1Passed: false).
  // Build nothing on these.
  @Expose() gate1Passed!: boolean;
  @Expose() gate2Passed!: boolean;
  @Expose() gate2LowConfidence!: boolean;
}

export class DeliveryNoteVerification {
  @Expose() id!: string;
  @Expose() status!: DeliveryNoteVerifyStatus;
  @Expose() aiConclusion!: string;

  @Expose()
  @Type(() => DeliveryNoteVerificationDetails)
  details?: DeliveryNoteVerificationDetails;

  @Expose() changeStatusReason!: string;
  @Expose() updatedAt!: Date;
  @Expose() createdAt!: Date;
  @Type(() => User)
  @Expose() updatedBy!: User;
}
